// extracted by mini-css-extract-plugin
module.exports = {"ManageCampaign":"ManageCampaign_ManageCampaign__381XT"};